import React from 'react'
import './App.css'
import Links from './about/links'
import FAQ from './about/faq'

function App() {
  return (
    <div className="App">
      <header className="grid-1">
        <h1>Abandoned Arena</h1>
      </header>
      <div className="grid-2">
        <Links></Links>
      </div>
      <div className="grid-3">
        <FAQ></FAQ>
      </div>
    </div>
  )
}

export default App
